<div *ngFor="let item of dataModelResult.listItems">
{{item.title}}
</div>
